import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../api';
import Sidebar from '../components/Sidebar';
import DashboardHome from './DashboardHome';
import Leads from './Leads';
import Inbox from './Inbox';
import Appointments from './Appointments';
import Policies from './Policies';
import Analytics from './Analytics';
import Scraper from './Scraper';
import Templates from './Templates';
import AutomationPage from './AutomationPage';
import Settings from './Settings';
import AdminPanel from './AdminPanel';
import Licenses from './Licenses';
import Estimator from './Estimator';
import BudgetTracker from './BudgetTracker';
import Credits from './Credits';
import CPATracker from './CPATracker';
import { ToastProvider } from '../components/Toast';

const TITLES = {
  "":           "Dashboard",
  leads:        "Leads",
  inbox:        "Inbox",
  appointments: "Appointments",
  policies:     "Policies",
  analytics:    "Analytics",
  scrape:       "Lead Scraper",
  workflows:    "Workflows",
  licenses:     "State Licenses",
  estimator:    "Price Estimator",
  budget:       "Budget Tracker",
  credits:      "Credits",
  cpa:          "CPA Tracker",
  automation:   "24/7 Mode",
  settings:     "Settings",
  admin:        "Admin",
};

function Topbar({ title }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pulse, setPulse] = useState(false);
  const [credits, setCredits] = useState(null);

  useEffect(() => { const t = setInterval(() => setPulse(p => !p), 1800); return () => clearInterval(t); }, []);

  useEffect(() => {
    const loadCredits = () => api.getCredits().then(d => setCredits(d.credits ?? 0)).catch(() => {});
    loadCredits();
    const t = setInterval(loadCredits, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ height: 52, borderBottom: "0.5px solid var(--border)", background: "var(--bg2)", display: "flex", alignItems: "center", padding: "0 20px", gap: 12, flexShrink: 0 }}>
      <span style={{ fontSize: 15, fontWeight: 700, flex: 1, letterSpacing: "-0.3px", color: "var(--text)" }}>{title}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "var(--teal-light,#E1F5EE)", border: "0.5px solid #5DCAA5" }}>
        <span style={{ width: 7, height: 7, borderRadius: "50%", background: pulse ? "#1D9E75" : "#5DCAA5", display: "inline-block", transition: "background .4s" }} />
        <span style={{ fontSize: 11, fontWeight: 500, color: "#0F6E56" }}>AI running</span>
      </div>
      {credits !== null && (
        <button onClick={() => navigate('/dashboard/credits')} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: credits < 20 ? "rgba(224,92,92,0.1)" : "rgba(83,74,183,0.08)", border: "0.5px solid " + (credits < 20 ? "rgba(224,92,92,0.3)" : "rgba(83,74,183,0.2)"), cursor: "pointer" }}>
          <i className="ti ti-coin" style={{ fontSize: 13, color: credits < 20 ? "#E05C5C" : "#534AB7" }} aria-hidden="true" />
          <span style={{ fontSize: 12, fontWeight: 700, color: credits < 20 ? "#E05C5C" : "#534AB7" }}>{credits} credits</span>
        </button>
      )}
    </div>
  );
}

export default function Dashboard() {
  const location = useLocation();
  const path = location.pathname.split("/dashboard/")[1] || "";
  const title = TITLES[path] || "Dashboard";

  return (
    <ToastProvider>
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", background: "var(--bg)" }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <Topbar title={title} />
        <div style={{ flex: 1, overflow: "auto", padding: 20, paddingBottom: 80 }}>
          <div key={location.pathname} style={{ animation: "fadeIn 0.2s ease" }}>
          <Routes>
            <Route path="/"             element={<DashboardHome />} />
            <Route path="/leads"        element={<Leads />} />
            <Route path="/inbox"        element={<Inbox />} />
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/policies"     element={<Policies />} />
            <Route path="/analytics"    element={<Analytics />} />
            <Route path="/scrape"       element={<Scraper />} />
            <Route path="/workflows"    element={<Templates />} />
            <Route path="/licenses"     element={<Licenses />} />
            <Route path="/estimator"    element={<Estimator />} />
            <Route path="/budget"       element={<BudgetTracker />} />
            <Route path="/credits"      element={<Credits />} />
            <Route path="/cpa"          element={<CPATracker />} />
            <Route path="/automation"   element={<AutomationPage />} />
            <Route path="/settings"     element={<Settings />} />
            <Route path="/admin"        element={<AdminPanel />} />
          </Routes>
          </div>
        </div>
      </div>
    </div>
    </ToastProvider>
  );
}
